// config.js
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export default API_URL;

